import { createFileRoute } from "@tanstack/react-router";
import { PublicLayout } from "../shared/components/PublicLayout";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

export const Route = createFileRoute("/_public")({
  component: PublicLayout,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
